export default __webpack_public_path__ + "static/media/testimonialBg.cdf057e4.png";